module.exports = "//static.hsappstatic.net/ContentComponents/static-2.63389/img/payment_methods.png"